// src/context/SiteDataContext.jsx
import { createContext, useContext, useEffect, useState } from "react";
import { tempSiteData } from "@/data/tempSiteData";

const SiteDataContext = createContext();

export const SiteDataProvider = ({ children }) => {
  const [siteData, setSiteData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate API fetch with static data
    setTimeout(() => {
      setSiteData(tempSiteData);
      setLoading(false);
    }, 500);
  }, []);

  return (
    <SiteDataContext.Provider value={{ siteData, loading }}>
      {children}
    </SiteDataContext.Provider>
  );
};

export const useSiteData = () => useContext(SiteDataContext);
